/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpdateMentorShiftMutationVariables = Types.Exact<{
  id: Types.Scalars["Int"];
  name?: Types.Maybe<Types.Scalars["String"]>;
  start_time?: Types.Maybe<Types.Scalars["DateTimeISO"]>;
  end_time?: Types.Maybe<Types.Scalars["DateTimeISO"]>;
  location?: Types.Maybe<Types.Scalars["String"]>;
  max_count?: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type UpdateMentorShiftMutation = {
  updateMentorShift: Pick<
    Types.EventActivity,
    | "category"
    | "created_at"
    | "end_time"
    | "event_id"
    | "id"
    | "location"
    | "name"
    | "restrictions"
    | "start_time"
    | "updated_at"
  >;
};

export const UpdateMentorShiftDocument = gql`
  mutation UpdateMentorShift(
    $id: Int!
    $name: String
    $start_time: DateTimeISO
    $end_time: DateTimeISO
    $location: String
    $max_count: Float
  ) {
    updateMentorShift(
      id: $id
      name: $name
      start_time: $start_time
      end_time: $end_time
      location: $location
      max_count: $max_count
    ) {
      category
      created_at
      end_time
      event_id
      id
      location
      name
      restrictions
      start_time
      updated_at
    }
  }
`;

/**
 * __useUpdateMentorShiftMutation__
 *
 * To run a mutation, you first call `useUpdateMentorShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorShiftMutation, { data, loading, error }] = useUpdateMentorShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *      location: // value for 'location'
 *      max_count: // value for 'max_count'
 *   },
 * });
 */
export function useUpdateMentorShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMentorShiftMutation,
    UpdateMentorShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateMentorShiftMutation,
    UpdateMentorShiftMutationVariables
  >(UpdateMentorShiftDocument, baseOptions);
}
export type UpdateMentorShiftMutationHookResult = ReturnType<
  typeof useUpdateMentorShiftMutation
>;
export type UpdateMentorShiftMutationResult =
  ApolloReactCommon.MutationResult<UpdateMentorShiftMutation>;
export type UpdateMentorShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateMentorShiftMutation,
    UpdateMentorShiftMutationVariables
  >;
